import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { MotionConfig } from 'framer-motion';
import { AuthProvider } from '@/auth/AuthProvider';
import { ThemeProvider } from '@/auth/ThemeProvider';
import { TooltipProvider } from '@/components/ui/Tooltip';
import { SupportConfigProvider } from '@/api/legacy/support';
import { ErrorBoundary } from '@/components/system/ErrorBoundary';
import { AccessProvider } from '@/features/AccessProvider';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: { retry: 0 },
  },
});

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AccessProvider>
          <SupportConfigProvider>
          <TooltipProvider>
            <MotionConfig reducedMotion="user" transition={{ duration: 0.22, ease: [0.23, 1, 0.32, 1] }}>
            <ErrorBoundary scope="App">
              <RouterProvider router={router} />
            </ErrorBoundary>
            <Toaster
              position="top-right"
              theme="system"
              richColors
              closeButton
              toastOptions={{
                classNames: {
                  toast:
                    'border border-border bg-surface-elevated text-foreground shadow-soft rounded-md',
                },
              }}
            />
            </MotionConfig>
          </TooltipProvider>
          </SupportConfigProvider>
          </AccessProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
